import { render, staticRenderFns } from "./FileLink.vue?vue&type=template&id=0ea7aee7&scoped=true&"
import script from "./FileLink.vue?vue&type=script&lang=js&"
export * from "./FileLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea7aee7",
  null
  
)

export default component.exports